module.exports = __webpack_public_path__ + "img/attachment-black.ce304812.svg";